import React, { useState } from "react";
import SecondaryNavbar from "../HomePage/Navbar/SecondaryNavbar";

import { useLanguage } from "../../context/LanguageContext";

import dataEn from "../../languages/en/AccountActivation.json";
import dataTh from "../../languages/th/AccountActivation.json";

const AccountActivationPage = () => {
  const { selectedLanguage } = useLanguage(); // Use the context
  const data = selectedLanguage === "en" ? dataEn : dataTh;

  const [email, setEmail] = useState("");
  const [activationCode, setActivationCode] = useState(Array(6).fill(""));
  const [isEmailValid, setEmailValid] = useState(true);
  const [isActivationCodeValid, setActivationCodeValid] = useState(true);
  const [isFormSubmitted, setFormSubmitted] = useState(false);
  const [isFormValid, setFormValid] = useState(false);

  const validateEmail = (email) => {
    // Simple email validation regex
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  };

  const handleInputChange = (index, value) => {
    // Limit the input to only one character
    if (value.length <= 1) {
      const newActivationCode = [...activationCode];
      newActivationCode[index] = value;
      setActivationCode(newActivationCode);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate the activation code
    const isActivationCodeValid = activationCode.every(
      (code) => code.trim() !== ""
    );

    // Simple email validation
    const isEmailValid = validateEmail(email);

    // Update the state variables for email and activation code validation
    setEmailValid(isEmailValid);
    setActivationCodeValid(isActivationCodeValid);

    // Check if all fields are valid before submitting the form
    if (isEmailValid && isActivationCodeValid) {
      setFormValid(true);
      console.log("Form submitted successfully!");
      // Handle form submission here
    }

    // Set the formSubmitted state to true
    setFormSubmitted(true);
  };

  return (
    <div className="relative">
      <SecondaryNavbar />
      <div className="max-w-md mx-auto mt-8 p-4 bg-white rounded-lg">
        <h2 className="text-2xl font-bold mb-4"> {data.title} </h2>
        <p className="mb-4 text-xs text-gray-500">{data.subTitle}</p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-700"
            >
              {data.email} <span className="text-red-500">*</span>
            </label>
            <input
              id="email"
              type="email"
              autoComplete="email"
              placeholder={data.emailPlaceHolder}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={`mt-1 block w-full shadow-sm sm:text-sm rounded-lg p-2 pl-6 border 
              ${
                isFormSubmitted && !isEmailValid
                  ? "border-red-500"
                  : "border-gray-400"
              }`}
            />
            {isFormSubmitted && !isEmailValid && (
              <p className="mt-2 text-sm text-red-500">{data.submittedForm}</p>
            )}
          </div>
          <div className="flex-col">
            <label
              htmlFor="activationCode"
              className="block text-sm font-medium text-gray-700"
            >
              {data.activationCode}
              <span className="text-red-500">*</span>
            </label>
            <div className="flex">
              {Array.from({ length: 6 }, (_, index) => (
                <input
                  key={index}
                  type="text"
                  maxLength="1"
                  value={activationCode[index]}
                  onChange={(e) => handleInputChange(index, e.target.value)}
                  className={`flex-grow border p-2 mx-1 w-16 text-center border-gray-400 rounded-xl 
                  ${
                    isFormSubmitted && activationCode[index].trim() === ""
                      ? "border-red-500"
                      : ""
                  }`}
                />
              ))}
            </div>
            {isFormSubmitted && !isActivationCodeValid && (
              <p className="mt-2 text-sm text-red-500">
                {activationCode.every((code) => code.trim() === "")
                  ? data.validateActivationCode[0]
                  : data.validateActivationCode[1]}
              </p>
            )}
          </div>

          <button
            type="submit"
            className={`flex items-center justify-center w-full bg-gradient-to-r from-primary-900 to-primary-600 text-white py-4 rounded-full font-bold hover:bg-blue-600
            `}
          >
            {data.submit}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AccountActivationPage;
